import { render, staticRenderFns } from "./DonutChart04.vue?vue&type=template&id=d7221ad8&scoped=true&"
import script from "./DonutChart04.vue?vue&type=script&lang=js&"
export * from "./DonutChart04.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7221ad8",
  null
  
)

export default component.exports